import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from '../../redux/axios';

const initialState = {
  adddepartment: [],
  isFetching: false,
  isSuccess: false,
  isError: false,
  errorMessage: '',
};

export const addDepartment = createAsyncThunk(
  'user/adddepartments',
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState()
      let tokenStr = auth.user.token;
      const response = await axios.post('/api/department', udata, { headers: { "Authorization": `Bearer ${tokenStr}` } });

      //   let response = await axios({
      //     url: '/api/department',
      //     method: 'post',
      //     //timeout: 8000,
      //     headers: {
      //         //'Content-Type': 'application/json',
      //         "Authorization" : `Bearer ${tokenStr}`
      //     }
      // })

      let data = response.data;
      //  console.log(data)
      if (response.status === 200) {
        return data;
      }
      if (response.status === 201) {
        return data;
      }
      else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      if (!err.response) {
        throw err
      }

      return thunkAPI.rejectWithValue(err.response.data)
    }
  }
);

export const addDepartmentSlice = createSlice({
  name: 'adddepartment',
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    clearStateDepartment: (state, { payload }) => {
      state.adddepartment = [];
      state.isError = false;
      state.isSuccess = false;
      state.errorMessage = '';
    },
  },
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  extraReducers: {
    [addDepartment.fulfilled]: (state, { payload }) => {

      state.adddepartment = payload.data;
      state.isFetching = false;
      state.isSuccess = true;
      return state;
    },
    [addDepartment.pending]: (state) => {
      state.isFetching = true;
    },
    [addDepartment.rejected]: (state, { payload }) => {
      state.isFetching = false;
      state.isError = true;
      if (payload) {
        state.errorMessage = payload.message;
      }
      else {
        state.errorMessage = 'Internal error';
      }
    }
  },
});

export const { clearStateDepartment } = addDepartmentSlice.actions;

export function clearState() {

  return async (dispatch) => {
    dispatch(clearStateDepartment());
  }
}

export const addDepartmentSelector = (state) => state.adddepartment;

export default addDepartmentSlice.reducer;
